module.exports = __webpack_public_path__ + "static/img/icon-not-found.1597405.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-not-found.svg
// module id = pYfi
// module chunks = 27